import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWithingsOrderPost = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M26 9.75H21.75V9.25C21.75 6.075 19.175 3.5 16 3.5C12.825 3.5 10.25 6.075 10.25 9.25V9.75H6C5.44687 9.75 5 10.1969 5 10.75V27.5C5 28.0531 5.44687 28.5 6 28.5H26C26.5531 28.5 27 28.0531 27 27.5V10.75C27 10.1969 26.5531 9.75 26 9.75ZM12.5 9.25C12.5 7.31562 14.0656 5.75 16 5.75C17.9344 5.75 19.5 7.31562 19.5 9.25V9.75H12.5V9.25ZM24.75 26.25H7.25V12H10.25V14.75C10.25 14.8875 10.3625 15 10.5 15H12.25C12.3875 15 12.5 14.8875 12.5 14.75V12H19.5V14.75C19.5 14.8875 19.6125 15 19.75 15H21.5C21.6375 15 21.75 14.8875 21.75 14.75V12H24.75V26.25Z" })
});
export default SvgWithingsOrderPost;
